import Vue from 'vue'
import 'element-ui/lib/theme-chalk/index.css';
// import locale from 'element-ui/lib/locale/lang/en'
import App from './App.vue'
import Axios from "axios";

import ELEMENT from 'element-ui';
Vue.use(ELEMENT, { size: 'small', zIndex: 3000 });
// Vue.use({ locale })
// import * as BabylonViewer from 'babylonjs-viewer';

const url = "https://api.enu-nft.xyz"

Vue.prototype.globalVars = {
  contract: "0x9E12e22Ec828C202d92a9fEBc98Fd7c1E4d61fb3",
  chainId: "0x89", // polygon
  chainName: "Polygon"
};

// Example POST method implementation:
async function postData(url = '', data = {}) {
  // Default options are marked with *
  const response = await fetch(url, {
    method: 'POST', // *GET, POST, PUT, DELETE, etc.
    mode: 'cors', // no-cors, *cors, same-origin
    cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
    credentials: 'same-origin', // include, *same-origin, omit
    headers: {
      'Content-Type': 'application/json'
      // 'Content-Type': 'application/x-www-form-urlencoded',
    },
    redirect: 'follow', // manual, *follow, error
    referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
    body: JSON.stringify(data) // body data type must match "Content-Type" header
  });
  return response.json(); // parses JSON response into native JavaScript objects
}

Vue.prototype.api = {
  getRecord(address) {
    return postData(url + "/record", { address })
    // return Axios.post(url + "/record", {
    //   address
    // });
  },
  getSig(address) {
    return postData(url + "/sign", { address })

    // return Axios.post(url + '/sign', {
    //   address
    // })
  }
  // getFormatData() {
  //   web3.eth.abi.encodeFunctionCall({
  //     name: 'myMethod',
  //     type: 'function',
  //     inputs: [{
  //       type: 'uint256',
  //       name: 'myNumber'
  //     }, {
  //       type: 'string',
  //       name: 'myString'
  //     }]
  //   }, ['2345675643', 'Hello!%']);
  // }
};

new Vue({
  el: '#app',
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js